import { render, staticRenderFns } from "./DonutChart17.vue?vue&type=template&id=6557dded&scoped=true&"
import script from "./DonutChart17.vue?vue&type=script&lang=js&"
export * from "./DonutChart17.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6557dded",
  null
  
)

export default component.exports